import { render, staticRenderFns } from "./productInfoCoefficient.vue?vue&type=template&id=c2903fe6&scoped=true&"
import script from "./productInfoCoefficient.vue?vue&type=script&lang=ts&"
export * from "./productInfoCoefficient.vue?vue&type=script&lang=ts&"
import style0 from "./productInfoCoefficient.vue?vue&type=style&index=0&id=c2903fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2903fe6",
  null
  
)

export default component.exports